@if (!pdfBytes || pdfBytes.byteLength === 0) {
  <div class="empty" i18n="@@einvoice.pdf-view.no-source">No source PDF available.</div>
} @else {
  <section class="pdf-view" aria-label="Source PDF preview" i18n-aria-label="@@einvoice.pdf-view.aria-label">
    @if (loading) {
      <div class="status" i18n="@@einvoice.pdf-view.loading">Loading PDF preview…</div>
    }
    @if (errorMessage) {
      <div class="status status--error">{{ errorMessage }}</div>
    }
    @if (viewerPdfBytes) {
      <ng2-pdfjs-viewer
        class="pdf-view__viewer"
        [pdfSrc]="viewerPdfBytes"
        [pdfJsOptions]="pdfJsOptions"
        [downloadFileName]="pdfFileName"
        [showOpenFile]="false"
        [showAnnotations]="false"
        [showDownload]="true"
        [showPrint]="true"
        [showFullScreen]="false"
        [showFind]="true"
        [showSidebar]="true"
        [showViewBookmark]="true"
        [urlValidation]="false"
        [iframeTitle]="'Source PDF preview'"
        (onDocumentLoad)="onDocumentLoad()"
        (onDocumentError)="onDocumentError()">
      </ng2-pdfjs-viewer>
    }
  </section>
}